import { render, staticRenderFns } from "./ModalNomeSocial.vue?vue&type=template&id=5cad36e7"
import script from "./ModalNomeSocial.vue?vue&type=script&lang=js"
export * from "./ModalNomeSocial.vue?vue&type=script&lang=js"
import style0 from "./ModalNomeSocial.vue?vue&type=style&index=0&id=5cad36e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports